import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import NewRelicProvider from './services/newrelic/NewRelicProvider';

import { SWRConfig } from 'swr';

import { AuthProvider } from '@sine/auth-client';
import { NotificationProvider } from '@sine/sine-ui-components';

import App from './App';
import Pendo from './components/Pendo/Pendo';
import ReCaptchaAuthProvider from './components/RecaptchaAuthProvider';
import { DeviceProvider } from './external/device';
import authService from './services/auth/auth.service';
import deviceService from './services/auth/device.service';
import notificationService from './services/notification/notification.service';
import './services/storage/storage.service';
import './services/team/team.service';
import { swrConfig } from './shared/swr';
import GlobalStyles from './theme/GlobalStyles';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <GlobalStyles />
    <NotificationProvider notificationService={notificationService}>
      <SWRConfig value={swrConfig}>
        <DeviceProvider deviceServiceInstance={deviceService}>
          <AuthProvider authService={authService}>
            <NewRelicProvider>
              <BrowserRouter basename={window.env.PUBLIC_URL}>
                <ReCaptchaAuthProvider>
                  <Pendo />
                  <App />
                </ReCaptchaAuthProvider>
              </BrowserRouter>
            </NewRelicProvider>
          </AuthProvider>
        </DeviceProvider>
      </SWRConfig>
    </NotificationProvider>
  </StrictMode>,
);
